<template>
  <div>
    <v-dialog v-model="dialog" width="600px" attach="#app-preview">
      <template #activator="{ on: dialog }">
        <v-tooltip top v-model="infosTooltip">
          <template #activator="{ on: tooltip }">
            <v-icon v-on="{ ...tooltip, ...dialog }" size="50"
              >mdi-information-outline</v-icon
            >
          </template>
          {{ $t("Click here for displaying infos") }}
        </v-tooltip>
      </template>
      <v-card>
        <v-card-title>
          <v-img
            v-if="imageSrc"
            :src="imageSrc"
            height="80"
            position="left center"
            contain
          ></v-img>
          <v-img
            v-else-if="imageUrl"
            :src="`/${imageUrl}`"
            height="80"
            position="left center"
            contain
          ></v-img>
          <v-img
            v-else
            src="@/assets/logo-tbc-solutions.png"
            height="80"
            position="left center"
            contain
          ></v-img>
        </v-card-title>
        <v-card-text v-if="info" class="title" style="white-space: pre-wrap">{{
          info
        }}</v-card-text>
        <v-card-text v-else class="title" style="white-space: pre-wrap"
          >{{ $t("infos-tbc") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="primaryColor"
            :dark="darkTheme"
            @click="dialog = false"
            >{{ $t("Close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "InfoDialog",
  data() {
    return {
      dialog: false,
      imageSrc: null,
      infosTooltip: true,
    };
  },
  computed: {
    ...mapState({
      info: (state) => state.customizations.editedItem.infos,
      primaryColor: (state) => state.customizations.primaryColor,
      darkTheme: (state) => state.customizations.editedItem.dark_theme,
      imageUrl: (state) => state.customizations.editedItem.image_url,
      image: (state) => state.customizations.editedItem.image,
      entityId: (state) => state.customizations.entityId,
    }),
  },
  watch: {
    image(value) {
      if (value) {
        let reader = new FileReader();
        reader.onload = () => {
          this.imageSrc = reader.result;
        };

        reader.readAsDataURL(value);
      } else {
        this.imageSrc = null;
      }
    },
    entityId() {
      this.infosTooltip = true;
    },
  },
};
</script>

<style scoped>
.v-dialog__content {
  position: absolute;
}
</style>